import React from 'react';
import { FieldInheritanceType } from '../../_utils/fieldComparison';
import InheritanceBadge from './InheritanceBadge';

interface FieldInheritanceBadgeProps {
  type: FieldInheritanceType;
  organizationId?: string | null;
}

/**
 * Badge component to display the inheritance status of a field in a child template
 * Shows whether a field is same as parent, modified from parent, or new in child
 * Labels differ based on template type:
 * - Global/jurisdiction templates (organizationId === null): parent/child terminology
 * - Agency templates (organizationId !== null): Lexipol/agency terminology
 */
export const FieldInheritanceBadge: React.FC<FieldInheritanceBadgeProps> = ({ type, organizationId = null }) => (
  <InheritanceBadge
    type={type}
    entity='field'
    organizationId={organizationId}
  />
);

export default FieldInheritanceBadge;
